import { Injectable } from "@angular/core";
import { CacheManager } from "src/app/cache/cache-manager";
import { CachedServicesRepository } from "../repositories/cached-services.repository";
import { StoredCachedService } from "src/app/driver/storage/models/stored-cached-service";

/**
 * Provides a cache manager for the cached services repository.
 * This prevents multiple simultaneous requests from the UI hitting the database.
 * This class extends the CacheManager to handle cached service data while using the CachedServicesRepository which extends the base.repository class to handle database operations.
 *
 * The direct use of the CachedServicesRepository should not happen. All access to cached service data should go through this cache manager.
 */
@Injectable({
	providedIn: 'root'
})
export class CachedServiceRepositoryCacheManager extends CacheManager<StoredCachedService> {

	/**
	 * @constructor
	 *
	 * @param cachedServicesRepository Repository used to interact with the cached services.
	 */
	constructor(
		cachedServicesRepository: CachedServicesRepository
	) {
		super(cachedServicesRepository);
	}
}